import React from 'react'

import { Modal, ModalManager, Effect } from 'react-dynamic-modal'
import { GrClose } from 'react-icons/gr'

import './index.css'

export default function DefaultModal({ component, title, onClose }) {
    const body = document.getElementsByTagName('body')[0];

    body.style.overflow = 'hidden'

    /**
     * Close modal function
     */
    const closeModal = () => {
        ModalManager.close()
        body.style.overflow = 'auto'
        if (onClose)
            onClose()
    }

    const style = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 99999999,
            overflowX: 'hidden',
            overflowY: 'auto',
            perspective: 1300,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },

        content: {
            position: 'relative',
            border: '1px solid rgba(0, 0, 0, .2)',
            width: 'inherit',
            background: '#fff',
            overflow: 'auto',
            borderRadius: '4px',
            outline: 'none',
            boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
        }
    }


    return (
        <div className="DefaultModal">
            <Modal
                style={style}
                onRequestClose={() => { }}
                effect={Effect.Fall}>

                <div className="header">
                    <div className="title">
                        {title}
                    </div>

                    <div className="actions">
                        <GrClose onClick={closeModal} />
                    </div>
                </div>

                <div className="body">
                    {component}
                </div>
            </Modal>
        </div>
    )
}